// @flow
import type { selectOption } from "shared/constants/flowTypes";
import type { BusinessLocationHit } from "shared/utilities/searchBusinessLocations";
import type { BusinessLocationRecord } from "../records/BusinessLocationRecord";

export const formatLocationLabel = (location: BusinessLocationHit): string => {
  const city = location.address?.city;
  const state = location.address?.state;
  const cityState = city && state ? `${city}, ${state}` : city || state || "";

  return cityState ? `${location.name} — ${cityState}` : location.name;
};

export const parseLocationsById = (
  hits: Array<BusinessLocationHit>
): { [string]: BusinessLocationRecord } =>
  hits.reduce(
    (
      acc: { [string]: BusinessLocationRecord },
      hit: BusinessLocationHit
    ): { [string]: BusinessLocationRecord } => {
      const locationId = hit.locationId || hit.objectID;
      acc[locationId] = { ...hit, locationId };
      return acc;
    },
    {}
  );

export const parseLocationOptions = (
  hits: Array<BusinessLocationHit>
): Array<selectOption> =>
  hits.map((hit: BusinessLocationHit): selectOption => {
    const locationId = hit.locationId || hit.objectID;
    return {
      value: locationId,
      label: formatLocationLabel({ ...hit, locationId }),
    };
  });
